export default {
    props: {
      xiangqing:'',
    }
    ,
    data() {
      return {
        
        tableData:'',
  
       }
    },

    methods: {
      // 获取项目已添加任务列表
      getxiangmurenwu(){
            this.$post('project_tasks/search', {
                      offset:0,  
                      length:999,
                     token: this.$store.state.authority_management,
                      project_id: this.xiangqing.project_id,
            }).then(res => {
              this.tableData = res.data.result.data

            })
      },

    },

    mounted() {
      if(this.xiangqing.project_id){
          this.getxiangmurenwu();
        }

    }

  }